module.exports = __webpack_public_path__ + "static/img/图层70.d08aa85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层70.png
// module id = 6wdt
// module chunks = 0